module.exports = __webpack_public_path__ + "static/foyer-5deafc88ede217c16bb4e18f742ea988.mp3";